import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { Link } from '@occc/ui-design-system';
import { routeCreator as awardCatalogRouteCreator } from '@occc-app/routes/AwardCatalog/utils';

export const SweepstakesEntryAlert: React.FC = () => {
  return (
    <Alert severity='warning'>
      <AlertTitle>Sweepstakes Entry Awards</AlertTitle>
      <Typography>
        To create a sweepstakes, you must configure a Sweepstakes Entry in your{' '}
        <Link component={RouterLink} underline='none' to={awardCatalogRouteCreator.base()}>
          Awards Catalog.
        </Link>
      </Typography>
    </Alert>
  );
};
